import * as React from "react";
const AddItemMedium = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 47 47", fill: "currentColor", width: size || "47", height: size || "47", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M23 23V0h1v23h23v1H24v23h-1V24H0v-1z" }));
AddItemMedium.displayName = "AddItemMedium";
var AddItemMedium_default = AddItemMedium;
export {
  AddItemMedium_default as default
};
